import type { SelfOwnedWidgetDefinition } from '../WidgetDefinition';
import { faAperture } from '@fortawesome/pro-regular-svg-icons/faAperture';
import type { AlphaEyeWidgetModel } from 'src/models/AlphaEyeWidgetModel';
import type { AlphaEyeWidgetState } from 'src/models/AlphaEyeWidgetModel/AlphaEyeModel';
import { AlphaEyeWidgetModelImpl } from 'src/models/AlphaEyeWidgetModel/impl';

export const alphaEyeWidgetDefinition: SelfOwnedWidgetDefinition<AlphaEyeWidgetState, AlphaEyeWidgetModel> = {
    type: 'alpha-eye' as const,
    nameKey: 'widgets::alpha-eye::name' as const,
    roles: ['widgets::alpha-eye', 'widgets::alpha-lens'],
    icon: faAperture,
    category: 'widgets::categories::research' as const,
    defaultDimensions: { h: 0.8, w: 0.33, x: 0.33, y: 0.1 },
    isLocalOnly: false,
    widgetClass: AlphaEyeWidgetModelImpl,
};
